import { Component, OnInit, Input } from '@angular/core';
import * as L from 'leaflet';
import isOnline from 'is-online';

import { MessageService } from 'primeng/api';
import { AggregationPopStatusDto } from '../../../data/models/aggregation-pop-status-dto';
import { LinesPopDto } from '../../../data/models/lines-pop-dto';
import { Subscription } from 'rxjs';
import { MapSubjectService } from '../../../services/map-subject.service';
import { MapService } from '../../../services/map.service';
import { MarkerService } from '../../../services/marker.service';
import { PopStatus } from '../../../data/enums/pop-status';
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  providers: [MessageService]
})
export class MapComponent implements OnInit {
  @Input() outerMap: boolean;
  @Input() lineId: number;
  @Input() lineName: string;
  @Input() popName: string;

  //////////may be need selected line id to get its coordinates if exist
  changesSubscriber: Subscription;

  map: any;
  bounds = L.latLngBounds([23.1342855, 31.6940474], [33.5042855, 30.5940474]);
  networkStatus: boolean;
  loader: boolean = true;
  observedLinesList: LinesPopDto[] = [];
  allPops: AggregationPopStatusDto[];

  constructor(private mapService: MapService, private messageService: MessageService, private MapSubjectService: MapSubjectService
    , private markerService: MarkerService) { }

  private initMap(): void {

    this.map = L.map('map', {
      center: [27.8206, 30.8025], // [29.4342855, 30.8940474],
      zoom: 5,
      minZoom: 5,
      maxBounds: L.latLngBounds([21.9342855, 25.8240474], [33.9342855, 36.7740474]),
      maxBoundsViscosity: 1

    });
    let tiles;
   // if (this.networkStatus) {
      tiles = L.tileLayer('https://{s}.google.com/vt?lyrs=m&x={x}&y={y}&z={z}&hl=en', {
        minZoom: 2,
        maxZoom:20,
        tileSize: 512,
        zoomOffset: -1,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      });
    //}
    //if (!this.networkStatus) {
    //  tiles = L.tileLayer('https://10.53.225.162:7007/Egypt/{z}/{x}/{y}.png', {
    //    maxZoom: 15,
    //    minZoom: 2,
    //    tileSize: 512,
    //    zoomOffset: -1
    //  });
    //}
    tiles.addTo(this.map);
  }

  ngOnInit() {

    this.loader = true;
    (async () => {
      this.networkStatus = await isOnline();
      if (!this.map)
        this.initMap();
        this.mapService.getAllClusteredPop().subscribe((res: AggregationPopStatusDto[]) => {
          res = res?.filter(r => r.latitude != 0 && r.longitude != 0 && r.latitude != null && r.longitude != null);
          if (res?.length>0) {
            //draw each pop on the map..
            //this.drawClusteredPops(res)
            this.allPops = res;
            this.drawAllMarkers(res);
            if (this.lineId) {
              //fly to selected line's pop
              let latlongs = res?.filter(x => x.popName == this.popName);
              (latlongs.length > 0)
                ? this.flyTheMap(latlongs?.map(x => ({ latitude: x.latitude, longitude: x.longitude })))
                : this.flyTheMap(res?.map(x => ({ latitude: x.latitude, longitude: x.longitude })));
            }
            else {
              this.flyTheMap(res?.map(x => ({ latitude: x.latitude, longitude: x.longitude })));
            }
          }
          this.loader = false;
        }, (error) => {
          this.loader = false;
          this.messageService.add({ severity: 'error', summary: 'Get Pops List Data', detail: 'sorry could not return data of the Pops now' })
        })
    })();
    
  }
  ngOnChanges() {
    if (this.lineId) {
      //fly to selected line's pop
      let latlongs = this.allPops?.filter(x => x.popName == this.popName);
      (latlongs?.length > 0)
        ? this.flyTheMap(latlongs?.map(x => ({ latitude: x.latitude, longitude: x.longitude })))
        : this.flyTheMap(this.allPops?.map(x => ({ latitude: x.latitude, longitude: x.longitude })));
    }
  }

  drawAllMarkers(pops: AggregationPopStatusDto[]) {
    //draw all clustered
    this.markerService.drawAllmarkers(this.map, pops)
    this.markerService.drawPolyLineByHQ(this.map,pops);
  }


  async drawPopsOnMap(pops: AggregationPopStatusDto[]) {
    await this.markerService.removeAllMarkers(this.map);
    pops = pops?.filter(p => p.latitude != 0 && p.longitude != 0)
    pops.forEach(async p => {
      if (p.latitude != 0 || p.longitude != 0) {
        this.markerService.DrawMarker(this.map, p);
      }
  })
    this.loader = false;
      this.flyTheMap(pops?.map(x => ({ latitude: x.latitude, longitude: x.longitude })));

  }

  flyTheMap(pops: any[]) {
    if (pops?.length>0) {
      let maxLat = Math.max(...pops?.map(p => p.latitude));
      let minLat = Math.min(...pops?.map(p => p.latitude));
      let maxLong = Math.max(...pops?.map(p => p.longitude));
      let minLong = Math.min(...pops?.map(p => p.longitude));
      this.bounds = L.latLngBounds([minLat, minLong], [maxLat, maxLong])
      this.map.flyToBounds(this.bounds);
    }
    else
      this.map?.flyToBounds(L.latLngBounds([23.1342855, 31.6940474], [33.5042855, 30.5940474]));
  }

}
